import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";

import { SERVICES } from "./services";
import { PIPES } from "./pipes";
import { COMPONENTS } from "./components";

import { reducers } from "./store/reducers";
import { Effects } from "./store/effects";
import { RouterModule } from "@angular/router";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
  providers: [...SERVICES],
  exports: [...COMPONENTS, ...PIPES],
  imports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    StoreModule.forFeature("core_feature", reducers),
    EffectsModule.forFeature(Effects),
    ...COMPONENTS,
    ...PIPES,
  ],
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [],
    };
  }
}
